import api from '../utils/API';

// Reprocessamento da tabela de preços no meio do dia (ipa-app → ipa-price-list-engine).
// validateStatus: false porque 204/403/409 fazem parte do contrato e a tela decide o que mostrar.

export type PriceListRerunStatus = 'SELECIONANDO' | 'EM_ANDAMENTO' | 'CONCLUIDO' | 'CONCLUIDO_COM_FALHAS' | 'SEM_ITENS';

export const PRICE_LIST_RERUN_RUNNING: PriceListRerunStatus[] = ['SELECIONANDO', 'EM_ANDAMENTO'];

export type PriceListRerunExecution = {
  executionId?: string;
  status?: PriceListRerunStatus;
  requestedBy?: string;
  startedAt?: string;
  finishedAt?: string | null;
  total?: number;
  written?: number;
  skippedApplied?: number;
  skippedOther?: number;
};

export type PriceListRerunResponse = PriceListRerunExecution & {
  httpStatus: number;
  message?: string;
};

export type PriceListRerunAvailability = {
  enabled: boolean;
  engineFinished: boolean;
  engineFinishedAt?: string | null;
  canStart: boolean;
  execution?: PriceListRerunExecution | null;
};

export const PRICE_LIST_RERUN_AVAILABILITY_QUERY_KEY = ['price-list-rerun-availability'] as const;

const BASE = `${process.env.REACT_APP_IPA_URL}/price-list/rerun`;

function call(url: string, method: 'GET' | 'POST'): Promise<PriceListRerunResponse> {
  // @ts-ignore
  return api({ url, method, expectToken: true, validateStatus: false }).then(resp => ({
    httpStatus: resp.status,
    ...(resp.data && typeof resp.data === 'object' ? resp.data : {}),
  }));
}

export const isPriceListRerunRunning = (status?: PriceListRerunStatus) => !!status && PRICE_LIST_RERUN_RUNNING.includes(status);

/** Itens que serão (ou foram) reprocessados: o total da seleção menos os pulados. */
export const priceListRerunCandidates = (r?: Pick<PriceListRerunExecution, 'total' | 'skippedApplied' | 'skippedOther'> | null) =>
  Math.max(0, (r?.total ?? 0) - (r?.skippedApplied ?? 0) - (r?.skippedOther ?? 0));

/** Sem flag, sem acesso ou falha na consulta: a tela trata como recurso indisponível. */
export const getPriceListRerunAvailability = async (): Promise<PriceListRerunAvailability> => {
  const r = await call(`${BASE}/availability`, 'GET');
  if (r.httpStatus !== 200) return { enabled: false, engineFinished: false, canStart: false };
  return r as unknown as PriceListRerunAvailability;
};

export const previewPriceListRerun = () => call(`${BASE}/preview`, 'GET');
export const startPriceListRerun = () => call(BASE, 'POST');
export const getPriceListRerunStatus = () => call(`${BASE}/status`, 'GET');
